<div class="card-container">
  <mat-card class="datex-card card"
            data-cy="card" 
            [ngStyle]="styles.style" 
            [ngClass]="styles.classes">
    <ng-container
                  *ngIf="initialized && !$hasMissingRequiredInParams">



      <mat-card-title-group class="card-header">
        <div class="card-title-container">
          <ng-content></ng-content>
          <mat-card-title data-cy="card-title" class="card-title card-title-link" (click)="on_open_order()">{{headerTitle}}</mat-card-title>
        </div>

      </mat-card-title-group>


      <mat-card-content data-cy="card-content" class="card-content" >
        <div [formGroup]="formGroupContent"
             class="formdata">
                <div data-cy="fieldset-formGroupContent-id-newGroup1"
                     *ngIf="!content.fieldsets.newGroup1.hidden && !content.fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': content.fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!content.fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="content.fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{content.fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="content.fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !content.fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': content.fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="content.fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-dates" *ngIf="!content.fields.dates.hidden && !content.fields.dates.removed" 
                            class="field-container full {{content.fields.dates.invalid ? 'invalid' : ''}} {{content.fields.dates.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="content.fields.dates.styles.style"
                            [ngClass]="content.fields.dates.styles.classes">
                        <div class="label-container"
                             [matTooltip]="content.fields.dates.label + (content.fields.dates.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{content.fields.dates.label}}<span *ngIf="content.fields.dates.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="dates"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (content.fields.dates.control.readOnly || content.fields.dates.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{content.fields.dates.control.placeholder}}"
                                [ngStyle]="content.fields.dates.control.styles.style"
                                [ngClass]="content.fields.dates.control.styles.classes"
                                [matTooltip]="content.fields.dates.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="content.fields.dates.invalid">
                          <ng-container *ngFor="let error of content.fields.dates.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-orders" *ngIf="!content.fields.orders.hidden && !content.fields.orders.removed" 
                            class="field-container full {{content.fields.orders.invalid ? 'invalid' : ''}} {{content.fields.orders.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="content.fields.orders.styles.style"
                            [ngClass]="content.fields.orders.styles.classes">
                        <div class="label-container"
                             [matTooltip]="content.fields.orders.label + (content.fields.orders.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{content.fields.orders.label}}<span *ngIf="content.fields.orders.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" data-cy="textBox-multi" formControlName="orders"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (content.fields.orders.control.readOnly || content.fields.orders.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{content.fields.orders.control.placeholder}}"
                                [ngStyle]="content.fields.orders.control.styles.style"
                                [ngClass]="content.fields.orders.control.styles.classes"
                                [matTooltip]="content.fields.orders.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> </textarea>
                        <ng-container *ngIf="content.fields.orders.invalid">
                          <ng-container *ngFor="let error of content.fields.orders.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!content.fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </mat-card-content>



    </ng-container>

    <div *ngIf="$hasMissingRequiredInParams"
        class="missing-params">
      <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
    </div>
  </mat-card>
  <div class="card-gripper"></div>
</div>